module.exports = __webpack_public_path__ + "img/Emergency Care.63c83444.png";